import React from 'react';
import './styles.css';
import Tooltip from '../../general/Tooltip';

const ChoiceButtons = ({
                           options,
                           value,
                           onChange,
                           disabled = false,
                           stacked = false,
                           size = 'sm',
                           styles = {},
                           className = ''
                       }) => {
    const renderOption = option => (
        <span className="choice-buttons__content">
            {option.icon && <span className="choice-buttons__icon" aria-hidden="true">{option.icon}</span>}
            <span className="choice-buttons__label">{option.label}</span>
        </span>
    );

    if (options.length === 1) {
        return <span className={className + ' choice-buttons__single'}>{renderOption(options[0])}</span>;
    }

    return (
        <div
            className={className + ' choice-buttons choice-buttons--' + size
                + (stacked ? ' choice-buttons--stacked' : '')}
            style={styles}
        >
            {options.map((option) => {
                const isOn = option.value === value;
                const isDisabled = disabled || option.disabled;

                const button = (
                    <button
                        type="button"
                        className={'choice-buttons__option'
                            + (isOn ? ' choice-buttons__option--on' : '')
                            + (option.disabled ? ' choice-buttons__option--locked' : '')}
                        disabled={isDisabled}
                        style={isDisabled && option.title ? {pointerEvents: 'none'} : undefined}
                        aria-pressed={isOn}
                        onClick={() => !isOn && onChange(option.value)}
                    >
                        {renderOption(option)}
                    </button>
                );

                if (option.title && isDisabled) {
                    return (
                        <Tooltip key={option.value} text={option.title} needTranslate={false} asChild>
                            <span className="choice-buttons__tooltip-anchor">
                                {button}
                            </span>
                        </Tooltip>
                    );
                }

                return option.title ? (
                    <Tooltip key={option.value} text={option.title} needTranslate={false} asChild>
                        {button}
                    </Tooltip>
                ) : React.cloneElement(button, {key: option.value});
            })}
        </div>
    );
};

export default ChoiceButtons;



// WEBPACK FOOTER //
// ./src/components-new/form/ChoiceButtons/index.jsx